import {ServiceMutations} from "./types";
import {STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";

export default {
    [ServiceMutations.REQUEST](state) {
        state.status = STATUS_LOADING;
    },
    [ServiceMutations.SUCCESS](state, data) {
        state.status = STATUS_SUCCESS;

        state.items = data.items;
        state.total = data.total;
    },
    [ServiceMutations.ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
        state.items = [];
        state.total = 0;
    },
    [ServiceMutations.SAVING](state, saving) {
        state.saving = saving;
    },
    [ServiceMutations.CONFIRM](state, id) {
        state.items.forEach(item => {
            if(item.service_request_id === id) {
                item.service_request_state = 2;
            }
        });
    },
    [ServiceMutations.DECLINE](state, id) {
        state.items.forEach(item => {
            if(item.service_request_id === id) {
                item.service_request_state = -1;
            }
        });
    },
}
